import { useAudio, useAudioTime } from '../../../../../contexts';
export var STATUS = {
  playing: 'playing',
  paused: 'paused',
  ended: 'ended'
};
export var useAudioStatus = function useAudioStatus() {
  var _useAudio = useAudio(),
      isPlaying = _useAudio.isPlaying,
      duration = _useAudio.duration;

  var _useAudioTime = useAudioTime(),
      currentTime = _useAudioTime.currentTime;

  if (isPlaying) return STATUS.playing;
  var ended = currentTime === duration && duration !== 0;
  return ended ? STATUS.ended : STATUS.paused;
};